import { API } from '@Providers';
import type { EquipmentRentalCartLinePayload } from './addEquipmentRentalToCart.service';

export interface AddFosterEquipmentRentalLinesPayload {
  equipment_lines: EquipmentRentalCartLinePayload[];
}

export default async function (payload: AddFosterEquipmentRentalLinesPayload) {
  const endpoint = '/api/shelter/foster/add-equipment-rental-lines';

  return API({ endpoint, method: 'post', payload });
}
